<template>
    <el-breadcrumb class="BreadcrumbGroup-box" separator-class="el-icon-arrow-right">
        <el-breadcrumb-item
            v-for="item in breadList"
            :key="item.name"
            :to="{ name: item.routerName }"
        >
            {{item.text}}
        </el-breadcrumb-item>
    </el-breadcrumb>
</template>

<script>
import { mapState } from 'vuex'
export default {
  computed: {
    ...mapState('common', {
      breadList: state => state.breadList
    })
  }
}
</script>

<style lang="scss" scoped>
.BreadcrumbGroup-box {
    margin: 20px 0;
    & /deep/ {
        .el-breadcrumb__inner {
            color: #999;
        }
    }
}
</style>
